// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"997":"c5f0e782","5361":"7c2f0582","8727":"c5f0e782"}[chunkId] + ".chunk.css";
};